import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";

export default function RequireAdmin({ children }) {
  const { admin, ready } = useAdminAuth();
  const loc = useLocation();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0b1114] text-white/70 text-sm">
        Caricamento…
      </div>
    );
  if (!admin) return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  return children;
}
